// src/components/leader/PasswordField.js - password input with a labelled show/hide toggle (FL-37).
import React, { useId, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { inputClasses } from './TextField';

export default function PasswordField({ id, label, hint, error, className = '', ...props }) {
  const autoId = useId();
  const fieldId = id || autoId;
  const [visible, setVisible] = useState(false);
  const hintId = hint ? `${fieldId}-hint` : null;
  const errorId = error ? `${fieldId}-error` : null;
  return (
    <div className={className}>
      <label htmlFor={fieldId} className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      <div className="relative">
        <input
          id={fieldId}
          type={visible ? 'text' : 'password'}
          aria-invalid={error ? true : undefined}
          aria-describedby={[hintId, errorId].filter(Boolean).join(' ') || undefined}
          className={`${inputClasses(Boolean(error))} pr-11`}
          {...props}
        />
        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? 'Skrýt heslo' : 'Zobrazit heslo'}
          aria-pressed={visible}
          className="absolute inset-y-0 right-0 mt-1 flex items-center rounded-r-md px-3 text-gray-500 hover:text-gray-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
        >
          {visible ? <EyeOff className="h-5 w-5" aria-hidden="true" /> : <Eye className="h-5 w-5" aria-hidden="true" />}
        </button>
      </div>
      {hint && (
        <p id={hintId} className="mt-1 text-xs text-gray-600">
          {hint}
        </p>
      )}
      {error && (
        <p id={errorId} className="mt-1 text-sm text-red-700">
          {error}
        </p>
      )}
    </div>
  );
}
